import { useEffect, useState } from "react";

type AssetPreviewProps = {
  assetId: string;
  token: string;
  className?: string;
  alt?: string;
};

export function AssetPreview({ assetId, token, className, alt }: AssetPreviewProps) {
  const [url, setUrl] = useState("");

  useEffect(() => {
    let active = true;
    let objectUrl = "";

    async function load() {
      if (!assetId || !token) {
        setUrl("");
        return;
      }
      try {
        const res = await fetch(`/v3/branding/assets/${assetId}/file`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) {
          return;
        }
        const blob = await res.blob();
        objectUrl = URL.createObjectURL(blob);
        if (active) {
          setUrl(objectUrl);
        }
      } catch {
        if (active) {
          setUrl("");
        }
      }
    }

    load();
    return () => {
      active = false;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [assetId, token]);

  if (!url) {
    return <div className={`bg-slate-100 ${className ?? ""}`} />;
  }

  return <img src={url} alt={alt ?? ""} className={className} />;
}
